import { Card } from 'shared/ui/card/card';
import Button from 'shared/ui/button/button';
import { WrappedIcon } from 'shared/ui/wrapped-icon/wrapped-icon';
import { useTranslation } from 'hooks';
import { ICONS } from 'shared/constants/images';
import cls from './rules-purpose.module.scss';

interface RulesPurposeProps {
  purposeText: string;
  implementedText: string;
  notImplementedText: string;
  onViewFullImpact: () => void;
  showViewFullImpact?: boolean;
}

export const RulesPurpose: React.FC<RulesPurposeProps> = ({
  purposeText,
  implementedText,
  notImplementedText,
  onViewFullImpact,
  showViewFullImpact = true,
}) => {
  const { t } = useTranslation();

  return (
    <Card className={cls.purposeCard}>
      <div className={cls.section}>
        <h4 className={cls.sectionTitle}>{t('purpose')}</h4>
        <p className={cls.sectionText}>{purposeText}</p>
      </div>

      <div className={cls.implementationSection}>
        <div className={cls.implementationItem}>
          <div className={cls.textBlock}>
            <h4 className={cls.sectionTitle}>{t('whenImplemented')}</h4>
            <p className={cls.sectionText}>{implementedText}</p>
          </div>
          <WrappedIcon
            pathToIcon={ICONS.checkMarkGreen}
            color='green'
            size={24}
          />
        </div>

        <div className={cls.implementationItem}>
          <div className={cls.textBlock}>
            <h4 className={cls.sectionTitle}>{t('whenNotImplemented')}</h4>
            <p className={cls.sectionText}>{notImplementedText}</p>
          </div>
          <WrappedIcon pathToIcon={ICONS.cross} color='red' size={24} />
        </div>
      </div>

      <div className={cls.impactSection}>
        <h4 className={cls.sectionTitle}>{t('whatTheseRulesImpact')}</h4>
        <div className={cls.impactText}>
          <p>{t('businessProfile')}</p>
          <p>
            {t('products')} & {t('services')}
          </p>
        </div>
        {showViewFullImpact && (
          <Button
            theme='tonal'
            tone='default'
            onClick={onViewFullImpact}
            className={cls.viewImpactBtn}
          >
            {t('viewFullImpact')}
          </Button>
        )}
      </div>
    </Card>
  );
};
